import dayjs from 'dayjs';
import { useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { useAppSelector } from '@/store';

import { CreateTabContext } from '../../../LlpOrder';
import { defaultInsuranceValues } from '../constants';
import { type CreateLeasingProps } from '../form-types';

const useLeasingForm = () => {
  const { request } = useAppSelector((state) => state.llpLeasingOrder);
  const { isFieldsFrozen } = useContext(CreateTabContext);

  const methods = useForm<CreateLeasingProps>({
    mode: isFieldsFrozen ? 'onSubmit' : 'all',
    defaultValues: defaultInsuranceValues
  });

  useEffect(() => {
    if (!request) return;
    const leasingSubjects =
      request.leasingSubjects.length > 0
        ? request.leasingSubjects.map((item) => ({
            info: {
              brand: { uuid: item.brand.name, name: item.brand.name },
              model: { uuid: item.model.name, name: item.model.name },
              year: String(item.year)
            },
            price: String(item.cost),
            count: String(item.quantity)
          }))
        : [{ info: undefined, price: '', count: '' }];
    const formData: CreateLeasingProps = {
      vehicles: leasingSubjects,
      leasingAmount: request.totalAmount || '',
      initialPayment: request.initialPayment || '',
      leasingPeriod: request.period || '',
      iin: request.iin || '',
      companyName: request.companyName || '',
      bankDetails: request.bankRequisits || '',
      oked: request.okedOfMainAndSubActivity || '',
      jobType: String(request.mainActivity?.code || ''),
      country: request.registrationCountry?.name || '',
      legalAddress: request.legalAddress || '',
      typeOfProperty: String(request.propertyType?.code || ''),
      registrationPlace: String(request.placeOfRegistration?.code || ''),
      registrationNumber: request.stateRegistrationNumber || '',
      registrationDate: request.stateRegistrationDate
        ? dayjs(request.stateRegistrationDate).format('YYYY-MM-DD')
        : '',
      startWork: request.workStartDate
        ? dayjs(request.workStartDate).format('YYYY-MM-DD')
        : '',
      license: request.licenseOrganizationAuthority || '',
      licenseDescription: request.licenseInformation || '',
      licenseNumber: request.licenseNum || '',
      fullName: request.clientFullName || '',
      phone: request.contactPhoneNumber || '',
      email: request.email || '',
      managerName: request.firstSupervisorFullName || '',
      managerDocument: String(request.docName?.code || ''),
      managerDocumentNumber: request.documentNumber || '',
      managerDocumentIssueDate: request.documentIssueDate
        ? dayjs(request.documentIssueDate).format('YYYY-MM-DD')
        : '',
      managerDocumentEndDate: request.documentValidEndDate
        ? dayjs(request.documentValidEndDate).format('YYYY-MM-DD')
        : ''
    };
    methods.reset(formData);
  }, [request]);

  return { methods };
};

export default useLeasingForm;
